import Flux from 'lib/flux';

const ContactConstants = Flux.createConstants({
  serviceMessages: ['SEND_MESSAGE'],
});

export default ContactConstants;
